export default __webpack_public_path__ + "static/opel-corsa-a2f388bfa594e06e6701f71445ff4be9.jpg";